import ActionDropdown from '@/components/basicComponents/actionDropdown';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { dateFormatter } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { format } from 'date-fns';
import styled from 'styled-components';
import { docusignRoutingTableColumns } from '../../constants';
import { WetSignatureUploadHistoryResponseDto } from '../../types';

interface MobileTableProps {
  signaturePacketTableData: WetSignatureUploadHistoryResponseDto[];
  viewSignaturePacket: (fileName: string) => Promise<void>;
}

const MobileTable = ({ signaturePacketTableData, viewSignaturePacket }: MobileTableProps) => {
  const TableRow = ({ el }: { el: WetSignatureUploadHistoryResponseDto }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue>{el?.versionDate && dateFormatter(format(new Date(el.versionDate), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.task}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.completedBy}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{docusignRoutingTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.email}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <ActionDropdownWrapper>
            <ActionDropdown
              actionDropdownListPosition="center"
              options={[{ name: 'View Signature Packet', onClick: () => viewSignaturePacket(el?.fileName) }]}
            />
          </ActionDropdownWrapper>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {signaturePacketTableData.length ? (
        signaturePacketTableData.map((el) => {
          return <TableRow el={el} key={guid()} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const ActionDropdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
